import { serviceApi } from '~/features';
import { ProductDeleteList } from '~/types';

export async function deleteProductList(id: string) {
  return serviceApi.delete<ProductDeleteList>(
    `/CampanhaProdutosPatrocinados/DeleteProdutosPatrocinados?campanhaId=${id}`
  );
}
